import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { getImportsKey } from '~/swr-hooks/importer/useImportTasks';

export const useRefreshImportTasks = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const queryClient = useQueryClient();
  const workspaceId = currentWorkspace?.id;

  const refreshImports = useCallback(
    () => queryClient.invalidateQueries({ queryKey: getImportsKey({ workspaceId }) }),
    [queryClient, workspaceId],
  );

  return {
    refreshImports,
  };
};
